// extracted by mini-css-extract-plugin
export default {"formContainer":"NewServiceForm_formContainer__FWtxk","formGroup":"NewServiceForm_formGroup__vtBDK","submitButton":"NewServiceForm_submitButton__qmWLk"};